// extracted by mini-css-extract-plugin
export default {"Link":"Link_Link__J6RGU"};